/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useSystemConfigurationFormStyles = makeStyles(() => ({
  groupContainer: {
    margin: '20px 0 10px',
    display: 'flex',
    flexDirection: 'column',
  },
  group: {
    gap: '15px',
    marginTop: '20px',
  },
  formControl: {
    marginTop: 0,
  },
  languageInput: {
    maxWidth: '280px',
    width: '100%',
    marginTop: '16px',
  },
  checkboxes: {
    marginTop: '10px',
  },
  subOptions: {
    paddingLeft: '10px',
    display: 'flex',
    flexDirection: 'column',
  },
  subOptionTooltip: {
    marginTop: '-5px',
    marginLeft: '28px',
    color: 'rgba(0,0,0,0.6)',
  },
}));
